import(/* webpackMode: "eager" */ "/vercel/path0/src/app/platforms/page.tsx");
